import { useState } from "react";
import { LuCheck, LuFileText, LuHeadset } from "react-icons/lu";
import { SCHEME_IMAGES } from "../../../../config/insurers";
import { getSchemeImage } from "../../../../shared/utils/schemeImages";
import Button from "../../../../shared/components/Button";

const PolicyCard = ({
  Logo,
  navigate,
  policyStatus,
  carName,
  carReg,
  policyNumber,
  expiryDate,
  onClick,
}) => {
  const hasSchemeImage = Boolean(SCHEME_IMAGES[Logo]);
  const [isLogoLoaded, setIsLogoLoaded] = useState(!hasSchemeImage);

  const detailRows = [
    {
      label: "Policy status",
      value: (
        <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-font-semibold tw-text-dis-success">
          <LuCheck className="tw-h-4 tw-w-4" aria-hidden="true" />
          {policyStatus}
        </span>
      ),
    },
    { label: "Policy number", value: policyNumber },
    { label: "Expiry date", value: expiryDate },
  ];

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div className="tw-flex tw-flex-col tw-items-start tw-gap-3">
        {hasSchemeImage ? (
          <div className="tw-relative tw-flex tw-min-h-[60px] tw-w-fit tw-items-center">
            {!isLogoLoaded && (
              <div
                className="tw-absolute tw-inset-y-0 tw-left-0 tw-h-[60px] tw-w-[120px] tw-animate-pulse tw-rounded-md tw-bg-dis-field"
                aria-hidden="true"
              />
            )}
            {getSchemeImage(Logo, {
              onLoad: () => setIsLogoLoaded(true),
              onError: () => setIsLogoLoaded(true),
              className: isLogoLoaded ? "" : "tw-opacity-0",
              naturalWidth: true,
            })}
          </div>
        ) : (
          getSchemeImage(Logo, { square: true })
        )}
        {carReg && (
          <div className="tw-inline-flex tw-flex-wrap tw-items-center tw-gap-2 tw-mt-3">
            <span className="tw-rounded-md tw-bg-dis-sky-tint tw-px-2.5 tw-py-1 tw-text-dis-small tw-font-semibold tw-text-dis-deep-blue">
              {carReg}
            </span>
            {carName && (
              <span className="tw-text-dis-small tw-text-dis-text-muted">
                {carName}
              </span>
            )}
          </div>
        )}
      </div>

      <dl className="tw-m-0 tw-flex tw-flex-col">
        {detailRows.map(({ label, value }, index) => (
          <div
            key={label}
            className={`tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-3 ${
              index < detailRows.length - 1
                ? "tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-dis-border"
                : ""
            }`}
          >
            <dt className="tw-text-dis-small tw-text-dis-text-muted">
              {label}
            </dt>
            <dd className="tw-m-0 tw-text-right tw-text-base tw-font-semibold tw-text-dis-text">
              {value}
            </dd>
          </div>
        ))}
      </dl>

      <div className="tw-grid tw-grid-cols-3 tw-gap-2">
        <Button
          variant="soft"
          size="small"
          fullWidth
          className="tw-min-w-0 tw-px-2 tw-text-sm"
          onClick={() => navigate("/support?supportType=changePolicy")}
        >
          <span className="tw-whitespace-normal">Make a Change</span>
        </Button>
        <Button
          variant="soft"
          size="small"
          fullWidth
          className="tw-min-w-0 tw-px-2 tw-text-sm"
          onClick={() => navigate("/support?supportType=cancelPolicy")}
        >
          <span className="tw-whitespace-normal">Cancel Policy</span>
        </Button>
        <Button
          variant="main"
          size="small"
          fullWidth
          className="tw-min-w-0 tw-px-2 tw-text-sm"
          onClick={() => navigate("/claim")}
        >
          <span className="tw-whitespace-normal">Report a Claim</span>
        </Button>
      </div>

      <Button
        variant="soft"
        size="small"
        fullWidth
        leadingIcon={
          <LuFileText className="tw-h-4 tw-w-4" aria-hidden="true" />
        }
        onClick={onClick}
      >
        Policy documents
      </Button>
      <Button
        variant="dark"
        size="small"
        fullWidth
        leadingIcon={<LuHeadset className="tw-h-4 tw-w-4" aria-hidden="true" />}
        onClick={() => navigate("/landing/contact")}
      >
        Support
      </Button>
    </div>
  );
};

export default PolicyCard;
